import { createFileRoute } from '@tanstack/react-router';

// const CustomerMembersSettings = React.lazy(
//   () => import('@/modules/backoffice/customers/pages/CustomerMembersSettings'),
// );

export const Route = createFileRoute(
  '/_authenticated/backoffice/customers/$customerId/members',
)({
  head: () => ({
    meta: [{ title: 'Membros do Cliente' }],
  }),
  component: function Component() {
    // const { customerId } = Route.useParams();

    return <div />;
    // return <CustomerMembersSettings tenantId={customerId} />;
  },
});
